import { talkToSalesCtaViewedEvent } from '#pplx/frontend/apps/ask/talk-to-sales/analytics.js';
import { useTalkToSalesAction } from '#pplx/frontend/apps/ask/talk-to-sales/useTalkToSalesAction.js';
import { useTalkToSalesEligibility } from '#pplx/frontend/apps/ask/talk-to-sales/useTalkToSalesEligibility.js';
import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
/**
 * The single per-surface CTA contract shared by every talk-to-sales
 * component: eligibility gate, action seam, and the viewed impression (fired
 * on render, deduped per component instance). Returns null when the viewer is
 * ineligible — callers render nothing in that case.
 */
export function useTalkToSalesCta(surface) {
    const eligibility = useTalkToSalesEligibility();
    const { destination, getHref, openTalkToSales } = useTalkToSalesAction();
    const { impression } = useInstrumentation();
    if (!eligibility.eligible) {
        return null;
    }
    const { audience } = eligibility;
    const actionArgs = { surface, audience };
    impression(talkToSalesCtaViewedEvent({
        name: 'enterprise talk to sales cta viewed',
        data: { surface, audience, destination },
    }));
    return {
        audience,
        destination,
        href: getHref(actionArgs),
        open: (event) => openTalkToSales(actionArgs, event),
    };
}
//# sourceMappingURL=useTalkToSalesCta.js.map